import React, { ReactNode } from 'react';
import { DatePicker, Form, Text } from 'rsuite';

interface AnnotatedDatePickerProps {
  label: string;
  name: string;
  subtitle?: () => string | ReactNode | undefined;
  annotation?: () => string | undefined;
  onChange: (date: string | undefined) => void;
  dateConvertor?: (date: Date | null) => string | undefined;
  format?: string;
  disabled?: boolean;
}

const AnnotatedDatePicker = ({
  label,
  name,
  subtitle = () => undefined,
  annotation = () => undefined,
  onChange,
  dateConvertor = (date) => date?.toString(),
  format = 'MM-dd-yyyy',
  disabled = false,
  ...rest
}: AnnotatedDatePickerProps) => {
  const onInternalChange = (date: Date | null) => {
    const convertedDate = dateConvertor(date);
    onChange(convertedDate);
  };
  return (
    <>
      <Form.Group controlId={name}>
        <Form.ControlLabel>
          <Text className="text-bold">{label}</Text>
          <Text>{subtitle()}</Text>
        </Form.ControlLabel>

        <DatePicker
          name={name}
          oneTap
          editable={false}
          onChange={onInternalChange}
          format={format}
          placeholder={format}
          disabled={disabled}
          {...rest}
        />
        {annotation()}
      </Form.Group>
    </>
  );
};

export default AnnotatedDatePicker;
